import { AppContext } from '../../contexts/app-context.js';
import PropTypes from 'prop-types';
import { staticData } from './../../../static/json-place-holder';
import { withPrefix } from 'gatsby';
import React, { useContext, useEffect, useState } from 'react';

const Header = ({ notFound }) => {
  const { partnerData } = useContext(AppContext);
  const siteUrl = process.env.SITE_URL || '';
  const [toggleMenu, setToggleMenu] = useState(false);
  const partnerName = partnerData?.name?.toUpperCase();
  const { header } = staticData;
  const basePath = process.env.URL_PREFIX || '';
  const partnerLinkName = partnerName ? partnerName.replace(/'/g, '').replace(/\W+/g, '-').toLowerCase() : '';
  header?.headerLinks.forEach((element) => {
    if (element.id === '3') {
      if (partnerName && partnerName !== 'HOMESERVE' && partnerData?.website !== '/' && !partnerData?.website?.includes('homeserve.co.uk')) {
        const headerElement = element;
        if (partnerName.toLowerCase().includes('eon')) {
          headerElement.text = 'GO TO E.ON NEXT';
        } else {
          headerElement.text = partnerName ? `GO TO ${partnerName.replace(/-WRAPAROUND|-LANDLORDS/g, '')}` : '';
        }
        headerElement.url = partnerData?.website;
      } else if (partnerData?.website?.includes('homeserve.co.uk')) {
        const headerElement = element;
        headerElement.text = 'GO TO HOMESERVE';
        headerElement.url = partnerData?.website;
      } else {
        const headerElement = element;
        headerElement.text = '';
        headerElement.url = '';
      }
    } else if (element.id === '1') {
      const headerElement = element;
      if (partnerName === 'HOMESERVE') {
        headerElement.url = process.env.ENVIRONMENT === 'production' ? 'https://www.homeserve.co.uk/insurance-cover' : 'https://www.reghomeserve.co.uk/insurance-cover';
      } else {
        headerElement.url = partnerName ? `${basePath}/${partnerLinkName}` : '/';
      }
      if (partnerName?.toLowerCase()?.includes('boxt')) {
        headerElement.text = 'PRODUCTS & SERVICES';
        //headerElement.url = process.env.ENVIRONMENT === 'production' ? 'https://www.homeserve.co.uk' : 'https://www.reghomeserve.co.uk';
      }
      if (partnerData?.customCategoryPage !== null && !notFound) {
        headerElement.url = partnerData.customCategoryPage;
      }
    }
  });
  const headerItem = header?.headerLinks.filter(item => item.text !== '');

  let logoUrl;
  if (notFound) {
    logoUrl = withPrefix('/resources/images/homeserve-logo.svg');
  } else {
    logoUrl = withPrefix(`${siteUrl}${partnerData?.logo}`);
  }

  useEffect(() => {
    if (typeof (window) !== 'undefined') {
      const scriptDiv = document.querySelectorAll('#ZN_6QENrHUZ7Q6hUbA');
      scriptDiv.length > 0 && scriptDiv[0].setAttribute('aria-hidden', 'true');

      const extraDiv = document.querySelectorAll('gatsby-qod');
      extraDiv.length > 0 && extraDiv[0].setAttribute('aria-hidden', 'true');

      const queryOnDemandExtra = document.querySelectorAll('#query-on-demand-indicator-element');
      queryOnDemandExtra.length > 0 && queryOnDemandExtra[0].setAttribute('aria-hidden', 'true');

      const gatsbyAnnouncer = document.querySelectorAll('#gatsby-announcer');
      gatsbyAnnouncer.length > 0 && gatsbyAnnouncer[0].setAttribute('aria-hidden', 'true');
    }
  }, []);

  const menuClose = (event) => {
    event.code === 'Enter' ? setToggleMenu(!toggleMenu) : null;
  };

  return (
    <React.Fragment>
      <header>
        <nav className="navbar navbar-default" role="navigation">
          <div className="container">
            <div className="navbar-header">
              <a className="navbar-brand" href={`${header?.logoLink}`} role="link" id="logoNav" aria-label={`${partnerName} | Introducing HomeServe Logo`}>
                <div className="logo-wrapper">
                  <picture className="logo">
                    <img
                      src={logoUrl}
                      alt={`${partnerName} | Introducing HomeServe`}
                      //title={`${partnerName} - Logo`}
                      width="auto"
                      height="auto"
                    />
                    {/* <span className="sr-only">
                        {`${partnerName} | Introducing HomeServe`}
                      </span> */}
                  </picture>
                </div>
              </a>
              {
                (!notFound) && <button
                  type="button"
                  className="navbar-toggle collapsed"
                  data-toggle="colapse"
                  data-target="#navbar"
                  aria-expanded="false"
                  aria-controls="navbar"
                  onKeyDown={event => menuClose(event)}
                >
                  <span className="sr-only">Toggle navigation</span>
                  <div
                    id="nav-icon"
                    onClick={() => setToggleMenu(!toggleMenu)}
                    onKeyDown={event => menuClose(event)}
                    className={!toggleMenu ? 'close' : 'open'}
                  >
                    <span />
                    <span />
                    <span />
                  </div>
                </button>
              }
            </div>
          </div>
          {partnerName && <div className="container-fluid mt-2" id="full-width-nav">
            <div className="container">
              <div id="navbar"
                className={`navbar-collapse animated-dropdown ${(toggleMenu) ? '' : 'animated-dropdown-hide'}`}
              >
                <ul id="main-nav">
                  {headerItem?.map((point, index) => (
                    <li key={index}>
                      {(index === 2) ? <a href={point.url} target="_blank" role="link" aria-label={`${point.text}`}>
                        {point.text}
                      </a> : <a href={point.url} role="link" aria-label={`${point.text}`}>
                        {point.text}
                      </a>}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>}
        </nav>
      </header>
    </React.Fragment>
  );
};
export default Header;
Header.propTypes = {
  notFound: PropTypes.string
};
